import { validate, validatePhone } from "lib/rut";

export const selectUserDni = (user) => {
	if (typeof user.dni === "undefined") return null;
	return user.dni;
};

export const selectUserRut = (user) => {
	if (typeof user.rut === "undefined") return null;
	return user.rut;
};

export const isUserSsnValid = (user) => {
	const { rut, dni, guest } = user;
	if (guest) return true;
	return validate(rut) || Boolean(dni);
};

export const isUserPhoneValid = (user) => {
	const { phone, guest, notifications } = user;
	if (guest) return true;
	return validatePhone(phone);
};
